import { addCache } from 'api/caching'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { getCerebroHeaders } from '../../Cerebro/headers'
import { BannerRequestBody } from '../types'

import { CategoryPerformance } from './types'

export const getCategoryPerformanceFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<CategoryPerformance>> =>
    orgScopedApiClient.post(
        '/api/category_insights_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
addCache(getCategoryPerformanceFacts)

export const getBenchmarkingPerformanceFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<CategoryPerformance>> =>
    orgScopedApiClient.post(
        '/api/benchmarking_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
addCache(getBenchmarkingPerformanceFacts)

export const getCategoryPerformanceFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        `/api/category_insights_facts/aggregate/banner/export/`,
        params
    )

export const getCategoriesAndPerformanceData = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.post(
        '/api/category_insights_facts/categories/aggregate/banner/',
        params
    )
